import { render, staticRenderFns } from "./SidebarContentWrapper.vue?vue&type=template&id=1dfa0e3d&scoped=true&"
import script from "./SidebarContentWrapper.vue?vue&type=script&lang=js&"
export * from "./SidebarContentWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SidebarContentWrapper.vue?vue&type=style&index=0&id=1dfa0e3d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfa0e3d",
  null
  
)

export default component.exports